import Vue from 'vue';

import ireloAnalytics from '@/plugins/irelo-analytics';
Vue.use(ireloAnalytics);

import ireloApi from '@/plugins/irelo-api';
Vue.use(ireloApi);

import ireloStorage from '@/plugins/irelo-storage';
Vue.use(ireloStorage);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

/**
 * Import all Bootstrap-vue components that are used within multiple
 * components. This will reduce the need for importing them into every
 * component that needs one of these. This also ensures that we don't
 * pull in the entire bootstrap-vue component set, thereby reducing the
 * final bundle size significantly.
 */
import Button from 'bootstrap-vue/es/components/button/button';
import Dropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
import DropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
import Form from 'bootstrap-vue/es/components/form/form';
import FormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import FormInput from 'bootstrap-vue/es/components/form-input/form-input';
import InputGroup from 'bootstrap-vue/es/components/input-group/input-group';
import GridContainer from 'bootstrap-vue/es/components/layout/container';
import GridRow from 'bootstrap-vue/es/components/layout/row';
import GridFormRow from 'bootstrap-vue/es/components/layout/form-row';
import GridCol from 'bootstrap-vue/es/components/layout/col';
import Modal from 'bootstrap-vue/es/components/modal/modal';
Vue.component('b-button', Button);
Vue.component('b-dropdown', Dropdown);
Vue.component('b-dropdown-item', DropdownItem);
Vue.component('b-form', Form);
Vue.component('b-form-group', FormGroup);
Vue.component('b-form-input', FormInput);
Vue.component('b-input-group', InputGroup);
Vue.component('b-container', GridContainer);
Vue.component('b-row', GridRow);
Vue.component('b-col', GridCol);
Vue.component('b-form-row', GridFormRow);
Vue.component('b-modal', Modal);

const loggerConfig = {
	isEnabled: process.env.VUE_APP_LOG_ENABLED === 'true',
	logLevel: process.env.VUE_APP_LOG_LEVEL || 'info',
	showLogLevel: true,
	showMethodName: true,
	separator: '|',
	showConsoleColors: true,
};

import VueLogger from 'vuejs-logger';
Vue.use(VueLogger, loggerConfig);

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
	defaultPosition: 'toast-top-right',
	defaultTimeout: 3000,
});
